import { isObjectType } from 'graphql';
import extractFieldStructure from './extractFieldStructure.js';
import getFieldPathState from './getFieldPathState.js';

const getFieldsFromSchemaPath = (schema, path) => {
  const fieldPathState = getFieldPathState(schema, path);

  if (!fieldPathState || !isObjectType(fieldPathState.currentType)) {
    return null;
  }

  return extractFieldStructure(fieldPathState.currentType);
};

export default getFieldsFromSchemaPath;
